module.exports = __webpack_public_path__ + "img/candle.2f043117.jpeg";